import { render, staticRenderFns } from "./ImageFilePreview.vue?vue&type=template&id=ef47f59e&scoped=true&"
import script from "./ImageFilePreview.vue?vue&type=script&lang=js&"
export * from "./ImageFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./ImageFilePreview.vue?vue&type=style&index=0&id=ef47f59e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef47f59e",
  null
  
)

export default component.exports
import {QImg,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QImg,QBtn,QTooltip}, component.options.components || {})
